import React from "react";
import { COLORS } from "utils/styles";

const Grip = ({ snapshot, hide, hover, ...props }) => {
  const isDragging = Boolean(snapshot && snapshot.isDragging);
  const showGrip = Boolean(!hide && (hover || isDragging));

  if (showGrip) {
    const gripFill = isDragging ? COLORS.blue : COLORS.grip;

    return (
      <div
        style={{ width: 10 }}
        className="flex-shrink-0 absolute top-0 left-0 right-0 cursor-move overflow-hidden o-80"
      >
        <svg
          width={16}
          height={88}
          viewBox="0 0 16 88"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <title>{"Grip"}</title>
          <g fill={gripFill} fillRule="evenodd">
            <path d="M2.4 2.6h3v3h-3zM6.4 2.6h3v3h-3zM10.4 2.6h3v3h-3zM2.4 6.6h3v3h-3zM6.4 6.6h3v3h-3zM10.4 6.6h3v3h-3zM2.4 10.6h3v3h-3zM6.4 10.6h3v3h-3zM10.4 10.6h3v3h-3zM2.4 14.6h3v3h-3zM6.4 14.6h3v3h-3zM10.4 14.6h3v3h-3zM2.4 18.6h3v3h-3zM6.4 18.6h3v3h-3zM10.4 18.6h3v3h-3zM2.4 22.6h3v3h-3zM6.4 22.6h3v3h-3zM10.4 22.6h3v3h-3zM2.4 26.6h3v3h-3zM6.4 26.6h3v3h-3zM10.4 26.6h3v3h-3z" />
            <g>
              <path d="M2.4 30.6h3v3h-3zM6.4 30.6h3v3h-3zM10.4 30.6h3v3h-3z" />
            </g>
            <g>
              <path d="M2.4 34.6h3v3h-3zM6.4 34.6h3v3h-3zM10.4 34.6h3v3h-3z" />
            </g>
            <g>
              <path d="M2.4 38.6h3v3h-3zM6.4 38.6h3v3h-3zM10.4 38.6h3v3h-3z" />
            </g>
            <g>
              <path d="M2.4 42.6h3v3h-3zM6.4 42.6h3v3h-3zM10.4 42.6h3v3h-3z" />
            </g>
            <g>
              <path d="M2.4 46.6h3v3h-3zM6.4 46.6h3v3h-3zM10.4 46.6h3v3h-3z" />
            </g>
            <g>
              <path d="M2.4 50.6h3v3h-3zM6.4 50.6h3v3h-3zM10.4 50.6h3v3h-3z" />
            </g>
            <g>
              <path d="M2.4 54.6h3v3h-3zM6.4 54.6h3v3h-3zM10.4 54.6h3v3h-3z" />
            </g>
            <g>
              <path d="M2.4 58.6h3v3h-3zM6.4 58.6h3v3h-3zM10.4 58.6h3v3h-3z" />
            </g>
            <g>
              <path d="M2.4 62.6h3v3h-3zM6.4 62.6h3v3h-3zM10.4 62.6h3v3h-3z" />
            </g>
            <g>
              <path d="M2.4 66.6h3v3h-3zM6.4 66.6h3v3h-3zM10.4 66.6h3v3h-3z" />
            </g>
            <g>
              <path d="M2.4 70.6h3v3h-3zM6.4 70.6h3v3h-3zM10.4 70.6h3v3h-3z" />
            </g>
            <g>
              <path d="M2.4 74.6h3v3h-3zM6.4 74.6h3v3h-3zM10.4 74.6h3v3h-3z" />
            </g>
            <g>
              <path d="M2.4 78.6h3v3h-3zM6.4 78.6h3v3h-3zM10.4 78.6h3v3h-3z" />
            </g>
            <g>
              <path d="M2.4 82.6h3v3h-3zM6.4 82.6h3v3h-3zM10.4 82.6h3v3h-3z" />
            </g>
          </g>
        </svg>
      </div>
    );
  } else {
    return null;
  }
};

export default Grip;
